import * as LS from 'local-storage'
import { LEARNING_HUB_ROUTE } from 'config'

// Helpers for the admin "Preview Course" flow. The preview token is stashed
// in local-storage by CoursePreviewShell when the admin first lands on
// /learning-hub/course-preview, and survives every client-side navigation
// inside the course-preview subtree.
//
// The single source of truth for "is this navigation a preview?" is the URL
// path: any route under /learning-hub/course-preview is preview. The token
// lookup is keyed by course id so an admin who previewed course A and then
// course B in a different tab can't cross-feed tokens.

const PREVIEW_PATH_PREFIX = `${LEARNING_HUB_ROUTE}/course-preview`

export function isPreviewPath(pathname) {
  if (!pathname) return false
  return pathname.startsWith(PREVIEW_PATH_PREFIX)
}

export function getPreviewTokenForCourse(courseId) {
  if (!courseId) return null
  const storedCourseId = Number(LS.getPreviewCourseId())
  if (storedCourseId !== Number(courseId)) return null
  return LS.getPreviewToken() || null
}

export function previewPathPrefix() {
  return PREVIEW_PATH_PREFIX
}
